// extracted by mini-css-extract-plugin
export default {"Mascot":"Mascot-module__Mascot--pjmse","Image":"Mascot-module__Image--CxUCL"};